import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ScheduledCreative } from "../../../../assets/icons/svg/Scheduled-Creative.svg";
import { ReactComponent as Icon } from "../../../../assets/icons/svg/Schedule-creative-icon.svg";
import { useTopBar } from "../../../../context/TopBarContext";

const AddScheduledScreen: React.FC = () => {
  const navigate = useNavigate();
  const { setTitle, setShowBackButton, pushNavState } = useTopBar();
  const location = useLocation();

  useEffect(() => {
    const title = "Scheduled";
    const showBack = false;

    setTitle(title);
    setShowBackButton(showBack);

    pushNavState({
      path: location.pathname,
      title,
      showBackButton: showBack,
    });
  }, [location.pathname]);

  const handleScheduleClick = () => {
    navigate("/scheduled/schedule-creative"); // Updated path
  };

  return (
    <div className="fixed inset-20 2xl:inset-40 overflow-hidden flex items-center justify-center bg-white">
      <div className="flex flex-col items-center text-center space-y-4 max-w-md">
        <ScheduledCreative className="w-52 h-52 -mb-8" />
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold text-[#1F1F1F]">
            Schedule creative
          </h2>
          <p className="text-sm text-[#808191F5]">
            View your scheduled creatives intended for display screens here.
          </p>
        </div>
        <button
          onClick={handleScheduleClick}
          className="inline-flex items-center justify-center gap-2.5 w-[220px] h-12 px-1 bg-[#0BA6C7] hover:bg-[#0A99B9] text-white text-sm font-medium border border-[#0BA6C7] hover:border-[#0A99B9] rounded-xl transition-colors duration-200 active:bg-[#0991A8]"
        >
          <Icon className="w-6 h-6" />
          Schedule creative
        </button>
      </div>
    </div>
  );
};

export default AddScheduledScreen;
